class HomeTopBrands extends HTMLElement {
  connectedCallback() {
    var _a, _b;
    (_a = this.events) == null ? void 0 : _a.abort();
    (_b = this.observer) == null ? void 0 : _b.disconnect();
    this.events = new AbortController();
    const { signal } = this.events;
    this.track = this.querySelector("[data-brand-track]");
    this.prev = this.querySelector("[data-brand-prev]");
    this.next = this.querySelector("[data-brand-next]");
    if (!this.track || !this.prev || !this.next) return;
    this.prev.addEventListener("click", () => this.step(-1), { signal });
    this.next.addEventListener("click", () => this.step(1), { signal });
    this.track.addEventListener("scroll", () => this.updateButtons(), { passive: true, signal });
    this.observer = new ResizeObserver(() => this.updateButtons());
    this.observer.observe(this.track);
    this.querySelectorAll("[data-brand-card]").forEach((card) => this.observer.observe(card));
    document.addEventListener("shopify:block:select", (event) => {
      if (!this.contains(event.target)) return;
      const card = event.target.closest("[data-brand-card]");
      if (card) card.scrollIntoView({ block: "nearest", inline: "nearest", behavior: "auto" });
    }, { signal });
    this.updateButtons();
  }
  disconnectedCallback() {
    var _a, _b;
    (_a = this.events) == null ? void 0 : _a.abort();
    (_b = this.observer) == null ? void 0 : _b.disconnect();
  }
  updateButtons() {
    const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
    this.prev.disabled = this.track.scrollLeft <= 1;
    this.next.disabled = this.track.scrollLeft >= maximum - 1;
  }
  step(direction) {
    const card = this.querySelector("[data-brand-card]");
    if (!card) return;
    const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
    const stride = card.getBoundingClientRect().width + gap;
    const count = Math.max(1, Math.floor((this.track.clientWidth + gap) / stride));
    const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
    const left = Math.max(0, Math.min(maximum, this.track.scrollLeft + direction * count * stride));
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    this.track.scrollTo({ left, behavior: reducedMotion ? "auto" : "smooth" });
  }
}
if (!customElements.get("home-top-brands")) {
  customElements.define("home-top-brands", HomeTopBrands);
}
